import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import { message } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { create_customer_base_info, update_customer_base_info } from '@/api/mjstore-model';

export const event_obj = mitt();
export const btn_list = [
  {
    name: '编辑',
    clazz: 'primary',
    cb: (data: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '编辑基础信息',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'input',
              name: 'name',
              label: '基础信息名称',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写基础信息名称',
            },
            {
              type: 'input',
              name: 'content',
              label: '基础信息内容',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写基础信息内容',
            },
          ],
          rules: {
            name: [{ required: true, message: '请填基础信息名称' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            customer_base_info_id: data.id,
            name: data.name,
            content: data.content,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            update_customer_base_info(payload)
              .then(() => {
                message.success('编辑基础信息成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list = [
  {
    name: '新建',
    clazz: 'primary',
    cb: () => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '新建基础信息',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'remotemodal',
              name: 'customer_id',
              label: '会员姓名',
              disabled: false,
              placeholder: '请选择会员姓名',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-customer',
            },
            {
              type: 'input',
              name: 'name',
              label: '基础信息名称',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写基础信息名称',
            },
            {
              type: 'input',
              name: 'content',
              label: '基础信息内容',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写基础信息内容',
            },
          ],
          rules: {
            name: [{ required: true, message: '请填基础信息名称' }],
            customer_id: [{ required: true, message: '请选择会员姓名' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            customer_id: null,
            name: null,
            content: null,
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            create_customer_base_info(payload)
              .then(() => {
                message.success('新建基础信息成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
